
import { List, Grid, Image, Ellipsis, Button, SpinLoading } from 'antd-mobile';
import { 
    SearchOutline,
    EyeOutline
} from 'antd-mobile-icons';
import { ButtonView, MarketAvatarView, EllipsisView, CoinImgView } from './ViewUtil';
import React from 'react';
import { ConvertToRate } from './FactoryUtil';

export const CellLastPriceHeaderView = React.memo((props) => {
    return (
        <List.Item arrowIcon={false} {...props}>
            <div className='cellLastPriceView' style={{margin : '0', fontSize : '12px', color : 'gray'}}>
                <div style={{flex : '1'}}>Name</div>
                <div style={{margin : '0 10px'}}>
                    Last price
                </div>
                <div style={{minWidth : '86px', textAlign : 'right'}}>
                    Change
                </div>
            </div>
        </List.Item>
    )
});

export const CellLastPriceView = React.memo((props) => {
    var isAvatar = props.avatar
    if(isAvatar === undefined) {
        isAvatar = true
    }
    const item = props.item || {}
    const rate = ConvertToRate(item)
    return (
        <List.Item className='cellLastPriceItemView' arrowIcon={false} {...props}>
            <div className='cellLastPriceView'>
                {
                    isAvatar ? <MarketAvatarView src={item.logo}/> : ''
                }
                <div className='title'><EllipsisView content={item.symbol}/></div>
                <div className='last-price'>
                    <div className='top'>{item.close}</div>
                    <div className='bottom'>{item.close} $</div>
                </div>
                <div className='right' style={{background : rate>=0 ? '#1FC586' : '#F23B52'}}>{rate}%</div>
            </div>
        </List.Item>
    )
});

export const CellCardView = React.memo((props) => {
    return (
        <List.Item arrowIcon={false} className='cellCardBorder' {...props}>
            {props.children}
        </List.Item>
    );
});

export const CellSearchView = React.memo((props) => {
    return (
        <List.Item  arrowIcon={false} className='cellSearchView' {...props}>
           <SearchOutline/> {props.children}
        </List.Item>
    );
});

export const CellAssetsHeaderView = React.memo((props) => {
    return (
        <List.Item  arrowIcon={false} className='cellAssetsHeaderView' {...props}>
           <div className='title'>Account Total Assets <EyeOutline/></div>
           <div className='balance'>{props.balance}$</div>
        </List.Item>
    );
});


export const CellAssetsView = React.memo((props) => {
    const fs = '12px'
    const item = props.item || {}
    return (
        <List.Item arrowIcon={false} className='cellAssetsView' {...props}>
           <div style={{
                display : 'flex',
                alignItems : 'center',
                marginBottom : '10px'
           }}>
             <CoinImgView src={item.logo || ''} style={{'--size' : '32px', '--border-radius' : '16px'}}/>
             <Ellipsis style={{wordBreak: 'break-word', padding : '0 10px'}} direction='end' content={item.symbol}/>
             <div style={{flex : '1', textAlign : 'right'}}>{item.equivalent}</div>
           </div>

           <Grid columns={3} style={{fontSize : fs, color : 'gray'}}>
                <Grid.Item style={{textAlign : 'left'}}>Available</Grid.Item>
                <Grid.Item style={{textAlign : 'center'}}>Freeze</Grid.Item>
                <Grid.Item style={{textAlign : 'right'}}>Last price</Grid.Item>
           </Grid>
           <Grid columns={3} style={{fontSize : fs, color : 'gray'}}>
                <Grid.Item style={{textAlign : 'left'}}>{item.available}</Grid.Item>
                <Grid.Item style={{textAlign : 'center'}}>{item.unusable}</Grid.Item>
                <Grid.Item style={{textAlign : 'right'}}>{item.price}</Grid.Item>
           </Grid>
        </List.Item>
    );
});

export const CellHeaderView = React.memo((props) => {
    return (
        <List.Item style={{fontSize : '18px', fontWeight : 'bold', margin : '15px 0'}} {...props}>
            {props.children}
        </List.Item>
    );
});

export const CellStateView = React.memo((props) => {
    const type = props.stateType;
    const color = '#B0B0B0';
    const ContentView = () => {
        if (type === 1) {
            return <>
                <div style={{ display : 'inline-block', textAlign : 'center'}}><Image width={140} height={140} placeholder='' src='./img/icon_empty.png'></Image></div>
                <div>
                    <Button onClick={props.onRefresh} style={{
                        '--border-color' : color,
                        '--border-radius' : '6px',
                        '--text-color' : color,
                        fontSize : '15px',
                        padding : '4px 10px',
                        marginBottom : '40px'
                        }}>Not data, click refresh</Button>
                </div>
            </>
        }
        else if(type === 2) {
            return <>
                <div style={{fontWeight : 'bold', margin : '10px 0'}}>Please login first</div>
                <ButtonView style={{fontSize : '13px'}} onClick={()=> {props.goLogin()}}>Login/Signup</ButtonView>
            </>
        }
        else if(type === 3) {
            return <div style={{display : 'flex', alignItems : 'center', justifyContent : 'center', margin : "20px 0"}}>
                <SpinLoading style={{'--size' : '20px', '--color' : color}}/>
                <div style={{margin : '10px 0', fontSize : '13px', padding : '0 10px', color : color}}>Loading...</div>
            </div>
        }
        else if(type === 4) {
            return <>
                <div style={{ display : 'inline-block', textAlign : 'center'}}><Image width={140} height={140} placeholder='' src='./img/icon_empty.png'></Image></div>
                <div style={{fontSize : '15px', color : color}}>Not data</div>
            </>
        }
        else {
            return <></>
        }
    }
    return (
        <List.Item {...props}>
            <div style={{textAlign : 'center'}}>
                <ContentView />
            </div>
        </List.Item>
    );
});


export const CellRecordView = React.memo((props) => {
    const color = props.color || '#000'
    const border = props.border || false
    return (
        <List.Item  className={border ? 'cellCardBorder' : ''} arrowIcon={false} {...props}>
            <Grid columns={3} gap={6} style={{fontSize : '14px', color : color, alignItems : 'center'}}>
                <Grid.Item>{props.left}</Grid.Item>
                <Grid.Item>{props.center}</Grid.Item>
                <Grid.Item style={{textAlign : 'right'}}>{props.right}</Grid.Item>
            </Grid>
        </List.Item>
    );
});

export const CellFourRowView = React.memo((props) => {
    var border = props.border
    if(border === undefined) {
        border = false
    }
    return (
        <List.Item className={border ? 'cellCardBorder' : ''} arrowIcon={false} {...props}>
            <Grid columns={4} gap={6} style={{fontSize : '13px'}}>
                <Grid.Item>{props.value_1}</Grid.Item>
                <Grid.Item>{props.value_2}</Grid.Item>
                <Grid.Item style={{textAlign : 'right'}}>{props.value_3}</Grid.Item>
                <Grid.Item style={{textAlign : 'right'}}>{props.value_4}</Grid.Item>
            </Grid>
        </List.Item>
    );
});